import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation, useNavigate } from 'react-router'
import './Layout.css'

import Footer from '../footer/Footer'
import Sidebar from '../sidebar/Sidebar'
import Loader from '../loader/view/Loader'
import { BASE_PATH_PREFIX, NOACCESS, UNAUTHORIZED } from '../../constants/routes'
import { useJwtExpirationWatcher } from '../../hooks/useJwtExpirationWatcher'
import { FocusRestoreProvider } from '../../contexts/FocusRestoreContext'
import SidebarCollapseContext from '../../contexts/SidebarCollapseContext'
import { setNavigate } from '../../utils/history'
import { isRoleAllowed } from '../../utils/commonUtils'

const SIDEBAR_COLLAPSE_KEY = 'sidebarCollapsed';

export const Layout = ({ isShowSidebar = true, isLoginPage = false, isPublic = false, roles = [], children }) => {
    const { isAuthLoading, userData } = useSelector(state => state.auth);
    const [menuCollapse, setMenuCollapse] = useState(() => {
        const stored = window.localStorage.getItem(SIDEBAR_COLLAPSE_KEY);
        return stored === null ? true : stored === 'true';
    });
    const location = useLocation();
    const autoCollapsedPathRef = useRef(null);
    const navigate = useNavigate();
    const isLoggedIn = !!userData?.UserId;
    const hasValidRole = !!userData?.RoleCode;

    useJwtExpirationWatcher(); // Watch for JWT expiration

    // Initialize navigate in the history utility
    useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);

    useEffect(() => {
        if (autoCollapsedPathRef.current !== null && autoCollapsedPathRef.current !== location.pathname) {
            autoCollapsedPathRef.current = null;
            setMenuCollapse(false);
        }
    }, [location.pathname]);

    const menuIconClick = () => {
        autoCollapsedPathRef.current = null;
        setMenuCollapse(prev => {
            const next = !prev;
            window.localStorage.setItem(SIDEBAR_COLLAPSE_KEY, String(next));
            return next;
        });
    };

    const setSidebarCollapsed = (collapsed = true) => {
        const nextCollapsed = collapsed !== false;
        autoCollapsedPathRef.current = nextCollapsed ? location.pathname : null;
        setMenuCollapse(nextCollapsed);
        window.localStorage.setItem(SIDEBAR_COLLAPSE_KEY, 'false');
    };

    const isHomePage = location.pathname === BASE_PATH_PREFIX;

    if (isLoggedIn && !hasValidRole && location.pathname !== UNAUTHORIZED) {
        return <Navigate to={UNAUTHORIZED} replace />;
    }

    if (!isPublic && !isRoleAllowed(roles, userData?.RoleCode)) {
        return <Navigate to={NOACCESS} replace />;
    }

    return (
        <div className={isLoginPage ? "login-layout" : ""}>
            {isShowSidebar
                ? <Sidebar menuIconClick={menuIconClick} menuCollapse={menuCollapse} userData={userData} />
                : null
            }
            <Loader show={isAuthLoading}>
                {isLoginPage
                    ? children
                    : (
                        <div className={`${menuCollapse ? "collapse-main-warpper" : "main-wrapper"} ${!isShowSidebar ? "no-sidebar" : ""}`}>
                            <div className={`p-3 ${isHomePage ? "main-content-home" : "main-content"}`}>
                                <div className={isHomePage ? "inner-content-home" : "inner-content"}
                                    style={isHomePage ? { backgroundImage: 'url("/assets/images/HomeBG.jpg")' } : {}}
                                >
                                    <FocusRestoreProvider>
                                        <SidebarCollapseContext.Provider value={setSidebarCollapsed}>
                                            {children}
                                        </SidebarCollapseContext.Provider>
                                    </FocusRestoreProvider>
                                </div>
                            </div>
                        </div>
                    )
                }
            </Loader>
            <Footer menuCollapse={menuCollapse} />
        </div>
    )
}

export default Layout;